import * as React from "react";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";

import * as questionIds from "../questions/questionIds";
import { HealthSurveillanceSectionProps } from "../models";
import { ChemicalUsageOptions } from "../questions/section7Questions";
import { sections } from "../questionnaire";

// eslint-disable-next-line max-len
const HealthSurveillanceSkinSectionTwoUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props: HealthSurveillanceSectionProps) => {
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.Skin2}
        >
            <h4>Which chemicals/substances do you work with where they can make contact with your skin and how often?</h4>
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.PaintsAndThinners)}
                readonly={props.readonly}
                options={ChemicalUsageOptions}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.LubeOilsGreases)}
                readonly={props.readonly}
                options={ChemicalUsageOptions}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.AdhedivesGlues)}
                readonly={props.readonly}
                options={ChemicalUsageOptions}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.GrindingAbrasives)}
                readonly={props.readonly}
                options={ChemicalUsageOptions}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.Solvents)}
                readonly={props.readonly}
                options={ChemicalUsageOptions}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.RegularHandWashing)}
                readonly={props.readonly}
                options={ChemicalUsageOptions}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.LaboratoryChemicals)}
                readonly={props.readonly}
                options={ChemicalUsageOptions}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.CleaningMaterials)}
                readonly={props.readonly}
                options={ChemicalUsageOptions}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.OrganicChemicals)}
                readonly={props.readonly}
                options={ChemicalUsageOptions}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.EpoxyResins)}
                readonly={props.readonly}
                options={ChemicalUsageOptions}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.Latex)}
                readonly={props.readonly}
                options={ChemicalUsageOptions}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.StrongAcidsAlkalis)}
                readonly={props.readonly}
                options={ChemicalUsageOptions}
            />
            <TextQuestion questionConfig={getQuestionConfig(props.questionConfigs, questionIds.SkinSymptomsDetails)} readonly={props.readonly} />
            <h4>Additional Questions</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HasJobCausedWorsedSkinCondition),
                    getQuestionConfig(props.questionConfigs, questionIds.HasJobCausedWorsedSkinConditionFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HadTreatmentForSkinCondition),
                    getQuestionConfig(props.questionConfigs, questionIds.HadTreatmentForSkinConditionFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.SeenDoctorSkinProblem),
                    getQuestionConfig(props.questionConfigs, questionIds.SeenDoctorSkinProblemFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceSkinSectionTwo = connect(makeMapStateToQuestionnaireSectionProps(sections.Skin2.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceSkinSectionTwoUnconnected);
